module.exports = __webpack_public_path__ + "media/images/socials/yc-af9c485ac1e5f1c35e69eab0612713d7.png";